<template>
    <div class="container-fluid container-fill">
        <div class="row">
            <div class="paper">
                <h2>
                    <router-link to="/Admin"><font-awesome-icon :icon="['fa', 'arrow-left']" class="pointer olive-green-text" /></router-link>
                    IP Restrictions
                    <font-awesome-icon :icon="['fa', 'sync-alt']" v-on:click="RefreshDataTable()" class="olive-green-text pointer" style="margin-right:0.5rem;" />
                    <font-awesome-icon :icon="['fa', 'plus']" class="pointer olive-green-text " @click="CreateIPRestrictionButton" />
                    <span class="AddOrEditModal">

                        <b-modal ref="component-modal" title="Add or Edit IP Restriction" hide-footer>
                            <b-container fluid>
                                <b-form @submit="AddOrEditIPRestriction">
                                    <b-row>
                                        <b-col cols="12"><b>Program:</b></b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="12" style="margin-bottom: 1rem">
                                            <select class="form-control" v-model="SubProgram" required :disabled="Id != ''">
                                                <option v-for="option in SubProgramOptions" :value="option.value">
                                                    {{option.text}}
                                                </option>
                                            </select>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="12"><b>Role:</b></b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="12" style="margin-bottom: 1rem">
                                            <select class="form-control" v-model="Role" required :disabled="Id != ''">
                                                <option v-for="option in RoleList" :value="option.Id">
                                                    {{option.Name}}
                                                </option>
                                            </select>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="12"><b>Allowed IPs:</b></b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="12" style="margin-bottom: 1rem"><b-form-input v-model="AllowedIPs" type="label" required></b-col>
                                    </b-row>
                                    <b-row class="modal-btn-row">
                                        <div class="modal-btn-row-div">
                                            <b-button size="md" variant="secondary" @click="Cancel()">
                                                CANCEL
                                            </b-button>
                                            <b-button size="md" variant="primary" type="submit">
                                                CONFIRM
                                            </b-button>
                                        </div>
                                    </b-row>
                                </b-form>
                            </b-container>
                        </b-modal>
                    </span>
                </h2>
                <vuetable :fields="IPRestrictionTableOptions.Fields"
                          :data-manager="DataManager"
                          pagination-path=""
                          :api-mode="false"
                          ref="datatable">
                    <template slot="IPRestrictionActions" scope="props">
                        <div class="IPRestrictionActionsDiv">
                            <b-row no-gutters>
                                <b-col md="auto">
                                    <font-awesome-icon :icon="['fa', 'edit']" style="font-size: 24px; margin-right:1rem;" class="pointer orange " @click="EditIPRestrictionButton(props.rowData)" />
                                </b-col>
                                <b-col md="auto">
                                    <ActionButtonWithIcon :requires-confirmation="true"
                                                          confirmation-string="WARNING: You are about to delete this IP Restriction.  Are you sure?"
                                                          :endpoint="'Admin/RoleSubProgramAccessRestriction/' + props.rowData.Id"
                                                          :perform-global-update="false"
                                                          button-variant="success"
                                                          button-string=""
                                                          button-size="md"
                                                          v-on:success="RefreshDataTable"
                                                          icon-prefix="fa"
                                                          icon-suffix="trash-alt"
                                                          icon-color="red"
                                                          method="DELETE" />
                                </b-col>
                            </b-row>
                        </div>
                    </template>
                </vuetable>
            </div>
        </div>
    </div>
</template>

<script>
    //import components
    import Vuetable from 'vuetable-2/src/components/Vuetable'
    // import helper functions
    import ActionButtonWithIcon from '../Admin/ActionButtonWithIcon.vue';
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faSyncAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faSyncAlt);
    import { faExchangeAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faExchangeAlt);
    import { faDownload } from '@fortawesome/free-solid-svg-icons';
    library.add(faDownload);
    import { faPlus } from '@fortawesome/free-solid-svg-icons';
    library.add(faPlus);
    import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faTrashAlt);
    import { faEdit } from '@fortawesome/free-solid-svg-icons';
    library.add(faEdit);
    import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
    library.add(faArrowLeft);
    import { EventBus } from '../../services/event-bus.js';
    export default {
        name: "IPRestriction",
        created() {
        },
        props: [],
        data: function () {
            return {
                Id: '',
                Role: '',
                SubProgram: '',
                AllowedIPs: '',
                IPRestrictions: [],
                RoleList: [],
                IPRestrictionTableOptions: {
                    Fields: [
                        {
                            name: 'SubProgram.Name',
                            title: 'Sub Program',
                            sortField: 'SubProgram'
                        },
                        {
                            name: 'Role.Name',
                            title: 'Role',
                            sortField: 'Role'
                        },
                        {
                            name: 'AllowedIPs',
                            title: 'AllowedIPs',
                            sortField: 'AllowedIPs'
                        },
                        {
                            name: '__slot:IPRestrictionActions',
                            title: 'Actions'
                        }
                    ]
                }
            };
        },
        methods: {
            EditIPRestrictionButton(rowData) {
                this.Id = rowData.Id;
                this.SubProgram = rowData.SubProgram.Id;
                this.Role = rowData.Role.Id;
                this.AllowedIPs = rowData.AllowedIPs;
                this.$refs['component-modal'].show();
            },
            CreateIPRestrictionButton(rowData) {
                this.Id = "";
                this.SubProgram = "";
                this.Role = "";
                this.AllowedIPs = '';
                this.$refs['component-modal'].show();
            },
            Cancel() {
                this.$refs['component-modal'].hide();
            },
            RefreshDataTable() {
                this.GetIPRestrictions();
            },
            GetIPRestrictions() {
                this.$MasterAPI.ExecuteRequest("GET", "Admin/RoleSubProgramAccessRestriction/", {}, this.GetIPRestrictionsSuccess, () => { }, true);
            },
            GetIPRestrictionsSuccess(response) {
                this.IPRestrictions = response.data.data;
                this.$refs.datatable.refresh();
            },
            AddOrEditIPRestriction(e) {
                e.preventDefault();
                if (this.Id == "") {
                    this.$MasterAPI.ExecuteRequest("POST", "Admin/RoleSubProgramAccessRestriction/", { RoleID: this.Role, AllowedIPs: this.AllowedIPs, SubProgramID: this.SubProgram }, this.AddOrEditIPRestrictionSuccess, () => { }, true);
                }

                else {
                    this.$MasterAPI.ExecuteRequest("PUT", "Admin/RoleSubProgramAccessRestriction/", { Id: this.Id, AllowedIPs: this.AllowedIPs}, this.AddOrEditIPRestrictionSuccess, () => { }, true);
                }
            },
            GetAllRoles() {
                this.$MasterAPI.ExecuteRequest("GET", "Admin/UserManagement/GetRoles", {}, this.GetAllRolesSuccess, () => { }, true);
            },
            GetAllRolesSuccess(response) {
                this.RoleList = response.data.data;
            },
            AddOrEditIPRestrictionSuccess(response) {
                this.RefreshDataTable();
                this.$refs["component-modal"].hide();
            },
            DataManager(sortOrder, pagination) {
                let dataset = this.filteredList(this.IPRestrictions);
                if (dataset.length > 0) {
                    if (sortOrder.length > 0) {
                        if (sortOrder[0].direction == 'asc') {
                            var firstComp = 1;
                            var secondComp = -1;
                        } else {
                            var firstComp = -1;
                            var secondComp = 1
                        }
                        return dataset.sort((a, b) => (this.$FindProperty(a, sortOrder[0].sortField) > this.$FindProperty(b, sortOrder[0].sortField)) ? firstComp : secondComp);
                    } else {
                        return dataset;
                    }

                } else {
                    return [];
                }
            },
            filteredList(inputData) {
                let vm = this;
                let tData = inputData
                if (tData == null) {
                    return [];
                }
                let tFields = vm.$refs["datatable"].tableFields;
                let visibleData = [];
                tData.forEach(function (row, index) {
                    let rowData = [];
                    tFields.forEach(function (field) {
                        rowData.push(vm.$refs.datatable.renderNormalField(field, row));
                    })
                    visibleData.push(inputData[index]);
                });
                return visibleData;
            },
            formatUTCDate(value, fmt = 'D MMM YYYY') {
                return (value == null)
                    ? ''
                    : moment.utc(value, 'YYYY-MM-DD HH:mm:ss').local().format(fmt)
            },
            GetEmployeePrivateProfile() {
                this.$MasterAPI.ExecuteRequest("GET", "Core/User/GetEmployeePrivateProfile", {}, this.GetEmployeePrivateProfileSuccess, () => { }, true);
            },
            GetEmployeePrivateProfileSuccess(response) {
                if (response.data.data == null) {
                    window.location = "/Identity/Account/Login";
                }
                this.$store.commit("User.PrivateProfile.Replace", response.data.data);
            },
        },
        components: {
            ActionButtonWithIcon,
            Vuetable,
        },
        computed: {
            SubProgramOptions: function () {
                return this.$store.getters["User.PrivateProfile.SubPrograms.GetSubProgramOptions"]();
            }
        },
        mounted() {
            this.GetEmployeePrivateProfile();
            this.GetIPRestrictions();
            this.GetAllRoles();
        }
    }
</script>

<style scoped>
</style>